import React, { useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../authConfig';
import './LoginPage.css';

export default function LoginPage() {
  const { instance } = useMsal();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSignIn = () => {
    setLoading(true);
    setError(null);
    instance.loginRedirect(loginRequest).catch((e) => {
      console.error('Login error:', e);
      setError('Sign in failed. Please try again.');
      setLoading(false);
    });
  };

  return (
    <div className="login-page">
      <div className="login-card">

        {/* Hex mark — paths from AppShell rail-logo, scaled to 64x64 viewBox, fill-only */}
        <div className="login-hex-mark">
          <svg
            width="80"
            height="80"
            viewBox="0 0 64 64"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill="#1D9E75"
              fillRule="evenodd"
              d="M32 3.2 L56.53 17.07 L56.53 46.93 L32 60.8 L7.47 46.93 L7.47 17.07 Z M32 6.6 L53.6 18.8 L53.6 45.2 L32 57.4 L10.4 45.2 L10.4 18.8 Z"
            />
            <path
              fill="#1D9E75"
              fillRule="evenodd"
              d="M44.9 32 A12.9 12.9 0 1 0 19.1 32 A12.9 12.9 0 1 0 44.9 32 Z M42.56 32 A10.56 10.56 0 1 1 21.44 32 A10.56 10.56 0 1 1 42.56 32 Z"
            />
            <circle cx="32" cy="32" r="4.27" fill="#1D9E75" />
          </svg>
        </div>

        <h1 className="login-product-name">ToolSight</h1>
        <p className="login-by-tmg">by TMG</p>
        <p className="login-tagline">Tooling lifecycle management for automotive manufacturing</p>

        <button
          className="login-sign-in-btn"
          onClick={handleSignIn}
          disabled={loading}
        >
          {loading ? 'Redirecting…' : 'Sign In'}
        </button>

        {error && <p className="login-error">{error}</p>}

        <p className="login-legal-text">
          By signing in, you agree to the{' '}
          <a href="/legal/terms">Terms of Use</a> and{' '}
          <a href="/legal/privacy">Privacy Notice</a>.
        </p>
      </div>

      <div className="login-footer">
        <span>&copy; 2026 Tooling Management Group LLC</span>
        <span className="login-footer-links">
          <a href="/legal/privacy">Privacy Notice</a>
          <span className="login-footer-sep">&middot;</span>
          <a href="/legal/terms">Terms of Use</a>
        </span>
      </div>
    </div>
  );
}
